class PriceOfferProperties {
    maxCount = 12

    constructor(offer, init = false) {
        this.el = offer ? $(offer).find("#template .properties") : [];

        this.table = this.el.find('.tableProperties');

        this.rowCount = 0;

        this.elements = this.table.find(".property");
        this.store = $(offer).find("form textarea#properties_store");
        this.removeButton = this.table.find(".remove");
        this.trash = $('.trash');
        this.tableWrap = $(".equipmentsWrap");
        this.alertElement = this.tableWrap.find(".oversizeAlert");
        this.row = this.elements.find("tr");

        this.newLineButton = this.el.find(".add-new-property");
        this.templateNewRow = this.el.find("template#new-row-property");

        this.recalculateRowCount();

        if (!this.el.length || !init) {
            return;
        }

        this.start();
        this.bind();
    }

    start() {
        this.initConfig();
        this.save();
        this.checkHeight();

        this.bind();
        // TODO: nefunguje contenteditable=true
        this.bindSortable(this.table.find('tbody'));
    }

    bind() {
        this.removeButton.off('click').on('click', (evt) => {
            this.remove(evt);
            this.save();
        });

        this.row.off('mouseenter').on('mouseenter', (evt) => {
            this.onRowMouseenter(evt);
        });

        this.elements.off('click').on('click', '.remove', (evt) => {
            this.removeRow(evt);
            return false;
        });

        $(document).off('keyup').on("keyup", ".properties td", (event) => {
            this.rowCount = this.el.find("tr:not(.ignore)").length;
            this.onChange($(event.currentTarget));
        });

        $(document).off('click').on("dblclick", ".property td", (event) => {
            $(event.currentTarget).find(".placeholder").focus();
        });

        this.newLineButton.off('click').on('click', () => {
            this.newLine();
        });
    }

    initConfig() {
        const config = this.table.data();

        this.maxCount = config.maxCount;
    }

    onChange(el) {
        this.save();
    }

    newLine() {
        this.recalculateRowCount();

        if (this.rowCount >= this.maxCount) {
            return;
        }

        const newRow = $(this.templateNewRow.clone().html());

        $(newRow).find('tr').attr("id", "new-row-property-"+this.rowCount);
        $(newRow).find('.delete-row').attr("data-row-id", "new-row-property-"+this.rowCount);

        this.table.find('tr:not(.ignore):last').after(newRow);

        setTimeout(() => {
            let newElement = $(`#new-row-property-${this.rowCount} td:first-child`);

            newElement.find(".placeholder:first-child").trigger("focus");
            //newElement.setSelectionRange(0, newElement.text().length);
        }, 100);

        this.save();
        // this.onChange();
    }

    deleteRow(element) {
        let rowToRemove = element.closest('tr');

        if (rowToRemove) {
            rowToRemove.remove();
        }

        this.recalculateRowCount();
        this.save();
    }

    bindSortable(elements) {
        elements.sortable({
            connectWith: '.sortable',
            // handle: 'div',
            cursor: "move",
            cursorAt: {
                top: 20,
                left: 20
            },
            helper: "clone",
            // forcePlaceholderSize: true,
            tolerance: "intersect",
            scroll: true,

            stop: (event, ui) => {
                this.save();
                elements.find(".placeholder").attr('contenteditable', true);
                console.log(elements.find(".placeholder"));
            },

            receive: function (event, ui) {
            }
        });

        this.bind();
    }

    remove(evt) {
        const removedEquipment = $(evt.currentTarget).parents().closest(".equipment");

        if (this.trash.length) {
            removedEquipment.appendTo(this.trash.find(".sortable"));

            // this.trashUpdate();
        } else {
            removedEquipment.remove();
        }

        this.recalculateRowCount();
        this.save();
        // PriceOffer.formChanged = true;
    }

    trashUpdate() {
        if (!this.store.length) {
            return;
        }

        const childrens = this.trash.find(".sortable").children();

        this.trash.toggleClass("hidden", childrens.length === 0);
    }

    save() {
        if (!this.store.length) {
            return;
        }

        const data = [];

        this.table.find(".property").each(function (columnIndex, el) {
            const label = $(el).find('td:first-child');
            const value = $(el).find('strong');

            data[columnIndex] = {
                label: label.text(),
                value: value.text(),
            }
        });

        const json = JSON.stringify(data);

        this.store.text(json);

        // this.trashUpdate();
        this.checkHeight();
    }

    checkHeight() {
        const scroll = this.tableWrap.find(".scroll");

        if (scroll.length > 0 && this.isScrollable(scroll)) {
            this.alert(true);
        } else {
            this.alert(false);
        }
    }

    isScrollable($div) {
        const element = $div[0]; // Get the native DOM element

        return element.scrollHeight > element.clientHeight;
    }

    alert(state) {
        this.alertElement.toggleClass("hidden", !state);
    }

    onRowMouseenter(evt) {
        const removeButton = $(evt.currentTarget).find(".remove");

        if (removeButton.length) {
            return;
        }

        $(evt.currentTarget).append('<a href="#" class="remove" icon="close" size="14"></a>');
    }

    removeRow(evt) {
        const targetRow = $(evt.currentTarget).closest("li");

        if (targetRow.length) {
            targetRow.remove();

            this.save();
            this.checkHeight();

            // PriceOffer.formChanged = true;
        }
    }

    recalculateRowCount() {
        this.rowCount = this.table.find(".property").length;
        this.newLineButton.attr("disabled", this.rowCount >= this.maxCount);
    }
}

window.PriceOfferProperties = PriceOfferProperties;

export default PriceOfferProperties;